// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

export class Controller {
    /** @ngInject */
    constructor(AccessRequestsService, ShowNoteModal, ConfirmDeleteModal, $state) {
        this.AccessRequestsService = AccessRequestsService;
        this.ShowNoteModal = ShowNoteModal;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
    }

    $onInit() {
    }

    showNote(requestDto){
        this.ShowNoteModal('Note', requestDto.note);
    }

    deleteRequest(requestDto) {
        this.ConfirmDeleteModal('Are you sure you want to delete this request')
            .then(() => {
                this.AccessRequestsService.deleteRequest(requestDto.id)
                    .then(() => this.$state.go('.', {}, {reload: '.'}))
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/access-requests/access-requests.controller.js